import React from 'react';
import Link from 'next/link';

export default function FooterSection() {
  return (
    <footer
      className="mt-12 px-6 py-8 text-center"
      style={{ borderTop: '1px solid var(--border)' }}
    >
      <p
        className="font-serif text-base font-semibold mb-1"
        style={{ color: 'var(--primary)' }}
      >
        ANGNA
      </p>
      <p className="text-xs mb-4" style={{ color: 'var(--muted-foreground)' }}>
        Bihar Ka Swad, Ghar Ka Pyaar
      </p>

      <div className="flex flex-col gap-1 items-center mb-4">
        <span
          className="text-sm font-medium"
          style={{ color: 'var(--secondary)' }}
        >
          79038 00338
        </span>
        <span
          className="text-sm font-medium"
          style={{ color: 'var(--secondary)' }}
        >
          81021 39165
        </span>
      </div>

      <Link
        href="/admin-login"
        className="inline-block w-3 h-3 rounded-full opacity-30 hover:opacity-60 transition-opacity duration-300"
        style={{ backgroundColor: 'var(--muted-foreground)' }}
        aria-label="Admin Panel"
      />
    </footer>
  );
}